<template>
  <!-- Contenedor principal de la aplicación -->
  <v-app id="pr-summit-de-ventas">
    <!-- 
      INDICADOR de carga
      Cuadro de dialogo que se indica que la aplicación está realizando algún proceso el usuario
      debe esperar.
      El trigger de este diálogo es la propiedad isLoading que se encuentra definida en el SATE (Vuex) de
      la aplicación y que puede ser accedida desde cualquier componente, a través de las accciones definidas
      en por el STATE (startLoader/stopLoader).
    -->
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-5">
          <!-- Obtenemos el mensaje en el IDIOMA seleccionado por el usuario -->
          <p v-html="$t('lblLoading')" />
        </v-card-text>
        <v-card-text>
          <!-- Indicador de progreso -->
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Header de la aplicación -->
    <v-app-bar app color="teal lighten-1 white--text elevation-0">
      <!-- Icono para abrir/cerrar el menú -->
      <v-app-bar-nav-icon
        color="white"
        @click.stop="isMenuVisible = !isMenuVisible"
      />

      <!-- Titulo de la app -->
      <v-row no-gutters>
        <v-col md="8" xs="12">
          <v-toolbar-title class="mt-sm-9"
            >Portal Subcontratación</v-toolbar-title
          ></v-col
        >
        <v-col md="4" class="d-none d-sm-block float-left">
          <router-link to="/">
            <v-img
              :src="require('@/assets/logo_palace.svg')"
              width="78px"
              height="50px"
              class="my-7 mr-12 float-right"
            ></v-img>
          </router-link>
        </v-col>
      </v-row>
    </v-app-bar>

    <!--
      Menú principal
    -->
    <v-navigation-drawer
      v-model="isMenuVisible"
      class="white"
      width="280"
      app
      temporary
      disable-resize-watcher
      floating
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar color="teal lighten-1">
            <v-icon dark> mdi-account-circle </v-icon>
          </v-avatar>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>
            Bienvenido/a
          </v-list-item-title>
          <v-list-item-subtitle style="white-space: normal !important;">
          {{ this.$store.getters["auth/name"] }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item
          router
          :to="option"
          v-for="(option, i) in options"
          :key="i"
        >
          <v-list-item-action>
            <v-icon color="black">{{ option.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title
              class="black--text"
              v-html="$t(option.label)"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>

        <v-list-item @click="signOut()">
          <v-list-item-action>
            <v-icon color="black">mdi-location-exit</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="black--text" v-html="$t('lblSignOut')" />
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <v-container fluid>
        <slot name="content"></slot>
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
.border-round-0 {
  border: 0px;
  border-radius: 0px;
}

a {
  text-decoration: none;
}

button.v-pagination__navigation {
  margin: 2px;
}

button.v-v-pagination__item {
  margin: 2px;
  padding: 2px;
}
</style>
<script>
/**
 * @copyright       Palace Resorts
 * @displayName     Member Layout
 * @description     Layout para las secciones que cuentan con una sesión iniciada.
 * @author          Roberto Pérez Guzmán
 * @creationDate    03 de Mayo del 2020
 */

// Incluimos los mensajes de este módulo
import i18nMessages from "./i18n/members.layout.messages";
// Inluimos mapGetters para tener acceso a las propiedades del STATE (Vuex)
import { mapGetters, mapActions } from "vuex";
//Incluimos el dashboard

// Incluimos el avatar
import Avatar from "@/components/Avatar/Avatar";
import { values } from "lodash";

// // let thisComponent = null;
export default {
  props: {
    /**
     * Titulo del módulo.
     */
    title: {
      type: String,
      required: true,
      default: "",
    },
    helpURL: {
      type: String,
      required: false,
    },
  },
  components: {
    Avatar,
  },
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  computed: {
    ...mapGetters({ roles: "auth/roles", isLoading: "isLoading" }),
  },
  // Información relativa al módulo
  data() {
    return {
      moduleName: "MEMBERS_LAYOUT",
      // Indicador para presentar/ocultar el menú
      isMenuVisible: false,
      isDashboardMinivariantEnable: false,
      // Opciones de menú
      options: [],
    };
  },
  created() {
    // Opciones de menú
    this.recursiveMenu(this.$router.options.routes);
  },
  methods: {
    recursiveMenu(routes) {
      routes.forEach((route) => {
        if (route.menu !== undefined) {
          if (route.menu.visible) {
            let isAllowed = true;
            // Filtramos las rutas registradas en Vue-router
            if (route.meta) {
              let { allow = ["*"], deny = [] } = route.meta;
              let isAllow =
                allow.includes("*") ||
                allow.includes(this.$store.getters["auth/rol"]);
              let isDeny =
                deny.includes("*") ||
                deny.includes(this.$store.getters["auth/rol"]);
              isAllowed = !isDeny && isAllow;
            }
            if (isAllowed) {
              this.options.push({
                to: route,
                icon: route.menu.icon,
                label: route.menu.label,
                name: route.name,
              });
            }
          }
        }
        if (route.children !== undefined) {
          this.recursiveMenu(route.children);
        }
      });
    },
    ...mapActions({ shiftLocale: "i18n/shiftLocale" }),

    /**
     * Ejecuta el proceso de cierre de sesión
     */
    signOut() {
      // Disparamos la solicitud para el cierre de sesión
      this.$store.dispatch("auth/signOut").then(() => {
        // Actualizamos la página para forzar el redireccionamiento a la pantalla de login
        window.location.replace("/");
      });
    },
  },
  watch: {
    isMenuVisible(value, oldValue) {
      this.$emit("menuVisibilityChanged", { value, oldValue });
    },
  },
};
</script>
